import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { IRule } from '@/classes/rules/IRule';
import { DefaultValue } from './DefaultValue';
import { Invalidation } from '@/classes/rules/Invalidation';
import { FieldUsage } from '@/classes/rules/FieldUsage';

const noDefaultValue = () => null;
const available = () => true;

/**
 * IRule to handle strings, uses either a Regex expression or a custom function to validate a string.
 */
export class TextRule<Context = ScenarioExt> implements IRule<Context> {

  public key: string;
  public regex: RegExp | undefined;
  public required: boolean = true;
  public displayed: boolean = true;
  public fieldUsage: FieldUsage;
  public getDefaultValue: (context?: Context) => DefaultValue<string> | null;
  public isAvailable: (context: Context) => boolean;

  public constructor(
    key: string,
    regex?: RegExp,
    isAvailable?: (context: Context) => boolean,
    checkValue?: typeof TextRule.prototype.checkValue,
    getDefaultValue?: (context?: Context) => DefaultValue<string> | null,
    required?: boolean
  ) {
    this.key = key;
    this.regex = regex;
    this.isAvailable = isAvailable ?? available;
    if (checkValue) {
      this.checkValue = checkValue;
    }
    this.getDefaultValue = getDefaultValue ?? noDefaultValue;
    if (required === false || required === true) {
      this.required = required;
    }
    this.fieldUsage = new FieldUsage();
  }

  public get invalidation(): Invalidation {
    return this.fieldUsage.getInvalidation();
  }

  public checkValue(val: string | null, context: Context): boolean | null {
    if (val === null) {
      return null;
    }
    return val !== '' && (this.regex?.test(val) ?? true);
  }

  public withIsAvailable(isAvailable: (context: Context) => boolean): this {
    this.isAvailable = isAvailable;
    return this;
  }

  public withDefaultValue(getDefaultValue: (context?: Context) => DefaultValue<string> | null): this {
    this.getDefaultValue = getDefaultValue;
    return this;
  }

  public withRequired(isRequired?: boolean): this { // true is default setting for this function
    this.required = isRequired !== false;
    return this;
  }

  public withFieldUsage(fieldUsage: FieldUsage): this {
    this.fieldUsage = fieldUsage;
    return this;
  }
}
